import { useLinking } from '@react-navigation/native';
import { Linking } from 'expo';

export default function(containerRef) {
  return useLinking(containerRef, {
    prefixes: [Linking.makeUrl('/')],
    config: {
      Landing: {
        path: ''
      },
      Campaign: {
        path: ':id'
      },
      Browse: {
        path: 'browse'
      },
      Admin: {
        path: 'admin'
      },
      About: {
        path: 'about'
      },
    },
  });
}
